// import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import moment from 'moment'
import lodash from 'lodash';
import vsFun from './common/vConsole'

import ResponseInterceptor from './plugins/responseInterceptor';

// 注册拦截器插件
Vue.use(ResponseInterceptor);

Vue.prototype._ = lodash

import plugin from './directive';
Vue.use(plugin); //防抖节流
//全局分享
// import VueBus from 'vue-bus'
// Vue.use(VueBus)
Vue.prototype.$moment = moment
Vue.prototype.$store = store
Vue.filter('formatDate', function (value) {
  return Moment(value).format('YYYY-MM-DD HH:mm:ss')
})
import {
  RadioGroup,
  Radio,
  Checkbox,
  CheckboxGroup,
  Button,
  Step,
  Steps,
  Swipe,
  SwipeItem,
  Form,
  Field,
  Calendar,
  Cell,
  CellGroup,
  Dialog,
  Notify,
  Popup,
  Picker,
  DatetimePicker,
  Area,
  Icon,
  Uploader,
  PasswordInput,
  NumberKeyboard,
  ActionSheet,
  Tag,
  List,
  ImagePreview,
  Popover,
  Overlay,
  Toast,
  Tab,
  Tabs,
  Sticky,
  NoticeBar,
  Image as VanImage,
  CountDown,
  Badge,
  Tabbar,
  TabbarItem,
  NavBar ,
  Grid,
  GridItem ,
  Empty ,
  SwipeCell,
  Loading,
  Switch                        
} from 'vant';
Vue.use(Tag).use(Tab).use(Tabs).use(ActionSheet).use(PasswordInput).use(NumberKeyboard).use(Picker).use(Popup).use(Dialog).use(Notify).use(Cell).use(CellGroup).use(Calendar).use(Field);
Vue.use(Form).use(Swipe).use(SwipeItem).use(Radio).use(RadioGroup).use(Checkbox).use(CheckboxGroup).use(Button).use(Step).use(Steps).use(DatetimePicker).use(Area).use(Icon).use(Uploader);
Vue.use(Popover).use(Overlay).use(Toast).use(Tab).use(Tabs).use(Sticky).use(NoticeBar).use(VanImage).use(CountDown).use(Badge).use(Tabbar).use(TabbarItem).use(List).use(ImagePreview).use(NavBar)
.use(Grid).use(GridItem).use(Empty).use(SwipeCell).use(Loading).use(Switch);

// import VueAwesomeSwiper from 'vue-awesome-swiper'
import { Swiper as SwiperClass, Pagination, Mousewheel, Autoplay } from 'swiper/swiper.esm'
import getAwesomeSwiper from 'vue-awesome-swiper/dist/exporter'
import '../node_modules/swiper/swiper-bundle.css'
SwiperClass.use([Pagination, Mousewheel, Autoplay])
Vue.use(getAwesomeSwiper(SwiperClass))
// Vue.use(VueAwesomeSwiper)
Vue.config.productionTip = false;
// import Bridge from '@assets/ios.js';
// Vue.prototype.$bridge = Bridge;

import IOS from "./components/ios";
Vue.prototype.IOS = IOS;

// import rem from "./components/rem";
// Vue.prototype.rem = rem;
// import utils from './util/util'
// Vue.prototype.utils = utils;
vsFun.isConsole()

// filters配置
import * as filters from './filters/index';
Object.keys(filters).forEach((key) => {
  Vue.filter(key, filters[key]);
});

// ajax相关配置
import api from "./config/api";
Vue.prototype.$api = api;
import {
  get,
  post,
  postFromeDate
} from "./config/https";
Vue.prototype.$get = get;
Vue.prototype.$post = post;
Vue.prototype.$postFromeDate = postFromeDate;
import {savePageParams,DevicePortraited} from './util/util'
Vue.prototype.$saveLog = savePageParams
Vue.prototype.DevicePortraited = DevicePortraited
router.beforeEach((to, from, next) => {
  console.log(to,from,'beforeEach.................')
  /* 路由发生变化修改页面title */
  document.title = to.name;

  if (to.meta.title) {
    document.title = to.meta.title;
  }
  // chrome
  document.body.scrollTop = 0;
  // firefox
  document.documentElement.scrollTop = 0;
  // safari
  window.pageYOffset = 0;
  next();
});
new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");